import {
  UI_CARD_HEIGHT_DEFAULT,
  UI_CARD_HEIGHT_DEFAULT_V2,
  UI_CARD_WIDTH_DEFAULT,
  UI_CARD_WIDTH_DEFAULT_V2,
} from "constants/ui";
import PropTypes from "prop-types";
import React from "react";
import ScaleToFit from "components/ScaleToFit";
import { useContentViewsContext } from "../../ContentViewsContext";

function CardPreview({ contentId, contentType }) {
  const { contentData } = useContentViewsContext();
  const isLayersV2 =
    contentData?.cardData?.template?.layoutId === "layers_v2" ||
    contentData?.cardData?.templateValues?.layoutId === "layers_v2";

  const iframeWidth = isLayersV2 ? UI_CARD_WIDTH_DEFAULT_V2 : UI_CARD_WIDTH_DEFAULT;
  const iframeHeight = isLayersV2 ? UI_CARD_HEIGHT_DEFAULT_V2 : UI_CARD_HEIGHT_DEFAULT;

  return (
    <ScaleToFit
      naturalWidth={iframeWidth}
      naturalHeight={iframeHeight}
      targetWidth={UI_CARD_WIDTH_DEFAULT}
    >
      <iframe
        width={iframeWidth}
        height={iframeHeight}
        title="Content Preview"
        scrolling="no"
        frameBorder="0"
        className="overflow-hidden mx-auto"
        src={`${process.env.REACT_APP_PLUGILO_PREVIEW_HOST}/contentPreview/${contentId}/${contentType}?actions=0&dt=0`}
        style={{
          boxShadow:
            "0px 20px 40px rgb(33 37 41 / 5%), 0px 0px 2px rgb(33 37 41 / 16%)",
          borderRadius: "16px",
        }}
      />
    </ScaleToFit>
  );
}

CardPreview.propTypes = {
  htmlContent: PropTypes.string,
};

export default CardPreview;
